if (!customElements.get('soho-tile-calculator')) {
  customElements.define('soho-tile-calculator', class extends HTMLElement {
    connectedCallback() {
      this.ready = () => this.initialize();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, {once:true});
      else this.initialize();
    }
    initialize() {
      if (this.initialized) return;
      this.info = this.closest('product-info');
      this.quantity = this.info?.querySelector('.quantity__input');
      if (!this.quantity) return;
      this.initialized = true;
      this.area = this.querySelector('[data-area-input]');
      this.waste = this.querySelector('[data-waste-input]');
      this.onArea = () => this.calculate();
      this.onQuantity = () => { this.area.value = ''; this.render(); };
      this.area.addEventListener('input', this.onArea);
      this.waste.addEventListener('input', this.onArea);
      this.quantity.addEventListener('change', this.onQuantity);
      this.quantity.addEventListener('input', this.onQuantity);
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) !== this.info.dataset.section) return;
        const updated = data.html.querySelector('soho-tile-calculator');
        if (updated) {
          this.dataset.area = updated.dataset.area;
          this.dataset.price = updated.dataset.price;
          this.querySelector('.soho-box-meta').innerHTML = updated.querySelector('.soho-box-meta').innerHTML;
        }
        if (Number(this.area.value) > 0) this.calculate(); else this.render();
      });
      this.render();
    }
    calculate() {
      const area = Math.max(0, Number(this.area.value) || 0);
      const waste = Math.max(0, Number(this.waste.value) || 0);
      const boxArea = Number(this.dataset.area);
      if (area > 0 && boxArea > 0) {
        const min = Number(this.quantity.min) || 1;
        const step = Number(this.quantity.step) || 1;
        const needed = Math.ceil(area * (1 + waste / 100) / boxArea);
        this.quantity.value = Math.max(min, min + Math.ceil((needed - min) / step) * step);
      }
      this.render();
    }
    render() {
      const boxes = Math.max(0, Number(this.quantity.value) || 0);
      this.querySelector('[data-coverage]').textContent = (boxes * Number(this.dataset.area)).toLocaleString(undefined, {minimumFractionDigits:2, maximumFractionDigits:2});
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.querySelector('[data-total]').textContent = money.format(boxes * Number(this.dataset.price) / 100);
      const unitPrice = this.querySelector('[data-unit-price]');
      if (unitPrice && Number(this.dataset.area) > 0) unitPrice.textContent = money.format(Number(this.dataset.price) / Number(this.dataset.area) / 100);
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded',this.ready);
      this.unsubscribe?.();
      this.quantity?.removeEventListener('change',this.onQuantity);
      this.quantity?.removeEventListener('input',this.onQuantity);
    }
  });
}
